function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M21.796 3c-5.634 0-10.43 3.584-12.234 8.597h9.335a1.5 1.5 0 010 3H8.872a13.141 13.141 0 000 2.8h4.226a1.5 1.5 0 110 3H9.561c1.804 5.014 6.6 8.598 12.235 8.598a12.93 12.93 0 007.799-2.599 1.5 1.5 0 011.802 2.399 15.93 15.93 0 01-9.601 3.2c-7.31 0-13.474-4.902-15.386-11.598H1.5a1.5 1.5 0 010-3h4.358a16.206 16.206 0 010-2.8H1.5a1.5 1.5 0 010-3h4.91C8.323 4.9 14.488 0 21.797 0c3.6 0 6.926 1.191 9.6 3.2a1.5 1.5 0 11-1.802 2.4A12.934 12.934 0 0021.796 3z",
  fill: "#E9688A"
})));